import { createAction } from 'redux-actions';
import { PageDataLayout } from '../../types/papi';

export const fetchPageLayoutSuccess = createAction<PageDataLayout>(
  'PAGE.LAYOUT.FETCH.SUCCESS'
);
